export default {
  data() {
    return {
      // These are available appStates
      appStates: {
        U: 'APP.NEW',
        N: 'APP.PENDING',
        J: 'APP.REJECTED',
        A: 'APP.READY_TO_PUBLISH',
        P: 'APP.PUBLISHED',
        R: 'APP.REMOVED',
        C: 'APP.NEED_TO_CHANGE',
        S: 'APP.SUSPENDED',
      },
    };
  },
  methods: {
    getAppState(state) {
      const stateMap = {
        ...this.appStates,
        // These are older appStates that were available many years ago, but we have
        // them only for safety
        B: 'APP.PUBLISHED_ONLY_ABROAD',
        D: 'APP.PURCHASE_DISABLED',
        H: 'APP.HIDDEN_FROM_DEV_PANEL',
        E: 'APP.REMOVED_BY_ERSHAD',
      };

      if (state in stateMap) {
        return this.$t(stateMap[state]);
      }

      return '';
    },

    getPackageState(state) {
      const stateMap = {
        N: 'APP.RELEASES.STATE.NEW',
        P: 'APP.RELEASES.PUBLISHED',
        R: 'APP.RELEASES.REJECTED',
        C: 'APP.RELEASES.ACCEPTED',
        S: 'APP.RELEASES.REMOVED',
      };

      if (state in stateMap) {
        return this.$t(stateMap[state]);
      }

      return '';
    },

    getReleaseState(state) {
      const stateMap = {
        accepted: 'APP.RELEASES.ACCEPTED',
        inactive: 'APP.RELEASES.INACTIVE',
        published: 'APP.RELEASES.PUBLISHED',
        waiting: 'APP.RELEASES.WAITING',
        rejected: 'APP.RELEASES.REJECTED',
        incomplete_accepted: 'APP.RELEASES.INCOMPLETE_ACCEPTED',
        editing: 'APP.RELEASES.EDITING',
      };
      if (state in stateMap) {
        return this.$t(stateMap[state]);
      }

      return '';
    },
  },
};
